// removed by extract-text-webpack-plugin
module.exports = {"layoutSwitcherContainer":"Yazdx","hideOnMobile":"_1LVlP"};